<button class="player-card" [ngStyle]="cardStyle">
  <ion-grid class="gradient__primary-secondary-45">
    <ion-row>
      <ion-col class="name-col ion-align-self-center ion-align-items-center ion-text-center" size="12">
        {{ player.surname }}
      </ion-col>
      <ion-col class="data-col ion-align-self-center ion-align-items-center ion-text-center" size="12">
        {{ player.team_code }}
      </ion-col>
    </ion-row>
  </ion-grid>
</button>
